<script lang="ts">
  import type { ScoreSnapshot } from "../../scoring/ScoreSystem";
  import type { IconName } from "../icons";
  import type { Translate } from "../i18n";
  import Icon from "./Icon.svelte";

  const { score, t }: { score: ScoreSnapshot; t: Translate } = $props();

  function clock(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const rest = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${rest}`;
  }

  /**
   * `tick` marks the rows worth animating when they change.
   *
   * Only the two that are *earned*: the clock changes every second and the
   * pace changes with it, so popping those would leave the board twitching
   * permanently and the credit would stop meaning anything.
   */
  const rows = $derived([
    {
      key: "score",
      title: t("stats.score"),
      value: score.score.toLocaleString(),
      icon: "trophy" as IconName,
      arrow: "arrow-up" as IconName,
      tick: true,
    },
    {
      key: "landings",
      title: t("stats.landings"),
      value: score.landings.toLocaleString(),
      icon: "plane-arrival" as IconName,
      arrow: "arrow-down" as IconName,
      tick: true,
    },
    {
      key: "departures",
      title: t("stats.departures"),
      value: score.departures.toLocaleString(),
      icon: "plane-departure" as IconName,
      arrow: "arrow-up" as IconName,
      tick: true,
    },
    {
      key: "pace",
      title: t("stats.pace"),
      value: `${score.pace.toFixed(1)}${t("stats.perMinute")}`,
      icon: "bolt" as IconName,
      arrow: "arrow-down" as IconName,
      tick: false,
    },
    {
      key: "duration",
      title: t("stats.duration"),
      value: clock(score.durationSeconds),
      icon: "clock" as IconName,
      arrow: "arrow-down" as IconName,
      tick: false,
    },
  ]);
</script>

<section id="flight-status" class="panel board" aria-label={t("stats.title")}>
  {#each rows as row (row.key)}
    <div class="board__row">
      <span class="board__arrow"><Icon name={row.arrow} size={22} /></span>
      <span class="board__icon"><Icon name={row.icon} size={20} /></span>
      <span class="board__copy">
        <span class="board__title">{row.title}</span>
      </span>
      <!--
        Keyed on the value for the earned rows, so a credit remounts the span
        and the CSS animation runs from the start. No timer to clean up.
      -->
      {#key row.tick ? row.value : row.key}
        <span class="board__value" class:board__value--tick={row.tick}
          >{row.value}</span
        >
      {/key}
    </div>
  {/each}
</section>
